/**
 * Marco de migração para o sistema novo (Smart Data): a partir de 01/09/2026 nenhuma OS nova
 * é aberta no sysin. Consulta e alteração das OS antigas seguem funcionando normalmente.
 *
 * A data de corte é 01/09/2026 00:00 no fuso America/Sao_Paulo, escrita aqui já como o instante
 * UTC equivalente (offset -03:00, constante no Brasil desde o fim do horário de verão em 2019),
 * para que o resultado não dependa do fuso configurado na máquina do usuário.
 *
 * Espelha src/shared/utils/BloqueioNovasOS.ts do backend, que é quem de fato garante o bloqueio.
 * Aqui a função existe para orientar o usuário antes de ele preencher o formulário inteiro.
 */
export const DATA_CORTE_NOVAS_OS = new Date('2026-09-01T03:00:00.000Z');

export const URL_SISTEMA_NOVO =
  'https://desenv.smartdatabi.com.br/innatura/login/?callback=dashboard/';

export function novasOSBloqueadas(agora: Date = new Date()): boolean {
  return agora.getTime() >= DATA_CORTE_NOVAS_OS.getTime();
}
